<template>
  <builderall-loader :loading="loadingAll" class="ba-card">
    <div v-if="hasExitPopupInBundleAccess" class="ba-alert ba-info ba-mg-b-1">
      <span>
        {{ $t('ct-website-locked-for-new-pages') }}
        <a @click="openCreateWebsite()">{{ $t('ct-click-here-to-create-website') }}</a>
      </span>
    </div>
    <div class="container-accordion-form ba-grid ba-gp-1" id="accordion">
      <div class="container-accordion-form ">
        <div class="card ba-w-100">
          <div
            class="card-header"
            id="popup"
            @click="show = 'popup'"
            :class="{'collapsed':!popup.expanded}"
            data-toggle="collapse"
            :data-target="`#collapse-popup`"
            :aria-expanded="popup.expanded"
            :aria-controls="`collapse-popup`"
            >
              <span class="py-1 d-block ba-text-14 ba-montserrat-600">
                Popup
                <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
              </span>
          </div>
          <div id="collapse-popup" aria-labelledby="Popup" class="collapse" :class="{ 'show': popup.expanded }" data-parent="#accordion">
            <FootersHeadersPopupsComponent :title="'Popup'" :type="'Popup'" :is_exit_popup_in_bundle_access="hasExitPopupInBundleAccess"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hasExitPopupInBundleAccess" class="container-accordion-form ba-grid ba-gp-1 ba-mg-t-1" id="accordion">
      <div class="container-accordion-form ">
        <div class="card ba-w-100">
          <div
            class="card-header"
            id="header"
            @click="show = 'header'"
            :class="{'collapsed':!header.expanded}"
            data-toggle="collapse"
            :data-target="`#collapse-header`"
            :aria-expanded="header.expanded"
            :aria-controls="`collapse-header`"
            >
              <span class="py-1 d-block ba-text-14 ba-montserrat-600">
                Header
                <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
              </span>
          </div>
          <div id="collapse-header" aria-labelledby="header" class="collapse" :class="{ 'show': header.expanded }" data-parent="#accordion">
            <FootersHeadersPopupsComponent :title="'Header'" :type="'Header'"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hasExitPopupInBundleAccess" class="container-accordion-form ba-grid ba-gp-1 ba-mg-t-1" id="accordion">
      <div class="container-accordion-form ">
        <div class="card ba-w-100">
          <div
            class="card-header"
            id="footer"
            @click="show = 'footer'"
            :class="{'collapsed':!footer.expanded}"
            data-toggle="collapse"
            :data-target="`#collapse-footer`"
            :aria-expanded="footer.expanded"
            :aria-controls="`collapse-footer`"
            >
              <span class="py-1 d-block ba-text-14 ba-montserrat-600">
                Footer
                <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
              </span>
          </div>
          <div id="collapse-footer" aria-labelledby="footer" class="collapse" :class="{ 'show': footer.expanded }" data-parent="#accordion">
            <FootersHeadersPopupsComponent :title="'Footer'" :type="'Footer'" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hasExitPopupInBundleAccess" class="container-accordion-form ba-grid ba-gp-1 ba-mg-t-1" id="accordion">
        <div class="container-accordion-form ">
            <div class="card ba-w-100">
                <div
                  class="card-header"
                  :id="item.id"
                  @click="show = item.id"
                  :class="{'collapsed':!item.expanded}"
                  data-toggle="collapse"
                  :data-target="`#collapse-${item.id}`"
                  :aria-expanded="item.expanded" :aria-controls="`collapse-${item.id}`"
                >
                    <span class="py-1 d-block ba-text-14 ba-montserrat-600">{{ $t(item.name) }}
                        <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                    </span>
                </div>
                <div :id="`collapse-${item.id}`" :aria-labelledby="`${item.id}`" class="collapse" :class="{ 'show': item.expanded }"
                    data-parent="#accordion">
                    <div class="card-body ba-w-100">
                      <GDPRSettings />
                    </div>
                </div>
            </div>
        </div>
    </div>
  </builderall-loader>
</template>

<script>
import FootersHeadersPopupsComponent from '../layout/items/FootersHeadersPopups';
import GDPRSettings from "../pages/GDPRSettings.vue";

export default {
  name: 'Items',
  components: { FootersHeadersPopupsComponent, GDPRSettings },
  data() {
    return {
      layout_id: '',
      website: {},
      loadingAll: false,
      item: {
        id: 'gdpr',
        name: 'GDPR',
        expanded: false
      },
      popup: {
        expanded: true
      },
      header: {
        expanded: false
      },
      footer: {
        expanded: false
      }
    };
  },
  computed: {
    hasExitPopupInBundleAccess() {
      const value = this.$route.query.is_exit_popup_in_bundle_access;
      return value == 'true' || value == '1';
    }
  },
  created() {
    this.loadingAll = true;
    setTimeout(() => {
      this.loadingAll = false;
    }, 1000);
  },
  methods: {
    openCreateWebsite() {
      this.$router.push({ name: 'CreateWebsite', query: { step: 'template' }});
    }
  },
};
</script>

<style lang="scss" scoped>
.ba-alert {
  a {
    margin-left: 0 !important;
    color: #0080fc;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: #0080fc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Items.vue